import * as THREE from 'three'
import GUI from "lil-gui";
import { EffectComposer, RenderPass, UnrealBloomPass } from "three/addons";
import { gsap } from "gsap";

export class AboutUsWebGl
{
    constructor( pageLoader )
    {
        let camera, scene, renderer, container;
        let composer;
        let time;

        let world;
        let texture;


        const distance = -250;
        let destinationCameraZ = distance;
        const bumpMap = document.createElement( 'canvas' );
        bumpMap.width = 256;
        bumpMap.height = 128;
        const bumpMapCtx = bumpMap.getContext('2d');

        const bumpImg = new Image();
        bumpImg.onload = function () {
            bumpMapCtx.clearRect(0,0, 256,128);
            bumpMapCtx.drawImage(this, 0, 0);
            pageLoader.onProgress();
            generateTexture();
        };
        bumpImg.src = '/assets/textures/ahd-icon-logo_256_128.jpg';


        function generateTexture() {

            const img = new Image();
            img.onload = function () {

                // canvas
                const imgCanvas = document.createElement( "canvas" );
                imgCanvas.width = this.width;
                imgCanvas.height = this.height;

                const context = imgCanvas.getContext( "2d" );
                const imageW = imgCanvas.width;
                const imageH = imgCanvas.height;

                context.fillStyle="#000000";
                context.fillRect(0,0,imageW,imageH);

                const stripH = 2;
                const gap = 8;

                // Credits to https://oosmoxiecode.com/archive/js_webgl/world/horizontal_lines.html
                for ( let i = 0; i < imageH; i+=gap )
                {
                    context.drawImage(
                        this,
                        0,i,
                        imageW,
                        stripH,
                        0,
                        i-(stripH/2),
                        imageW,
                        stripH
                    );
                }

                texture = new THREE.Texture( imgCanvas );
                texture.needsUpdate = true;

                pageLoader.onProgress();
                init();
                animate();
            };
            //img.src = "/assets/textures/Earth-Spec4096.jpg";
            img.src = "/assets/textures/ahd-icon-logo-2048_1024.jpg";
        }

        function init() {

            const gui = new GUI({ width: 325 })
            container = document.querySelector( '#about-us-canvas').parentNode;

            scene = new THREE.Scene();
            scene.fog = new THREE.Fog( 0x000000, 100, 300 );
            scene.background = new THREE.Color().setHex( 0xf8f9fa );

            camera = new THREE.PerspectiveCamera( 60, container.offsetWidth / container.offsetHeight, 1, 10000 );
            camera.position.z = distance;
            camera.lookAt(scene.position);
            scene.add( camera );

            const radius = 100;
            const sphereGeometry = new THREE.SphereGeometry( radius, 256, 256 );
            const sphereMaterial = new THREE.MeshBasicMaterial(
                {
                    color: 0xd0920b,
                    map: texture,
                    transparent: true,
                    blending: THREE.SubtractiveBlending,
                    wireframe: false,
                    side: THREE.DoubleSide,
                    depthWrite: false,
                    fog: true
                }
            );

            const matParams = {
                crapcolor:  "#00b4ff",
                color:  "#00b4ff",

            };
            gui.addColor(matParams, 'crapcolor').onChange(() => sphereMaterial.color.set( matParams.color ) );
            gui.addColor(matParams, 'color').onChange(() => sphereMaterial.color.set( matParams.color ) );
            gui.hide();


            /*
            const positionAttr = sphereGeometry.getAttribute( 'position' );
            const vertex = new THREE.Vector3();
            for ( let i = 0; i < positionAttr.count; i++ )
            {
                vertex.fromBufferAttribute( positionAttr, i );
                const lat = 90 - (Math.acos(-vertex.y / radius)) * 180 / Math.PI;
                const lon = ((270 + (Math.atan2(-vertex.x , -vertex.z)) * 180 / Math.PI) % 360) -180;
                const pixel_x = Math.floor( (256/360)*(lon+180) );
                const pixel_y = Math.floor( (128/180)*(lat+90) );
                const h = getHeight(pixel_x, pixel_y)/255;
                vertex.multiplyScalar(1+(h/7));
                positionAttr.setXY( i, vertex.x, vertex.y, vertex.z );
            }
             */

            world = new THREE.Mesh(sphereGeometry, sphereMaterial);
            world.rotation.y = Math.PI-0.4;
            scene.add(world);

            try {
                // renderer
                const sizes = {
                    width : container.offsetWidth,
                    height : container.offsetHeight,
                    pixelRatio: Math.min(window.devicePixelRatio, 2)
                };
                renderer = new THREE.WebGLRenderer({antialias: true, canvas: document.querySelector( '#about-us-canvas')});
                renderer.setSize(sizes.width, sizes.height);
                renderer.setPixelRatio(sizes.pixelRatio);
                renderer.setClearColor( 0xf8f9fa, 0);
                renderer.toneMapping = THREE.NoToneMapping;
                renderer.autoClear = false;

                // POST PROCESSING

                // define/add the RenderPass
                const renderScene = new RenderPass( scene, camera );

                // add a new UnrealBloomPass and add the values from the parameters above
                // const bloomPass = new UnrealBloomPass(
                //     new THREE.Vector2( sizes.width, sizes.height ),
                //     .06,
                //     0.04,
                //     0.5
                // );

                // finally, create a new EffectComposer and add the different effects
                composer = new EffectComposer( renderer );
                composer.addPass( renderScene );
                //composer.addPass( bloomPass );
                //THREEx.WindowResize(renderer, camera);

                // // postprocessing
                //
                // var renderModel = new THREE.RenderPass( scene, camera );
                // var effectBloom = new THREE.BloomPass( 1.0 );
                //
                // var effectHBlur = new THREE.ShaderPass( THREE.HorizontalBlurShader );
                // effectHBlur.uniforms[ 'h' ].value = 1.0 / window.innerWidth;
                //
                // var effectFocus = new THREE.ShaderPass( THREE.FocusShader );
                //
                // effectFocus.uniforms[ "screenWidth" ].value = window.innerWidth;
                // effectFocus.uniforms[ "screenHeight" ].value = window.innerHeight;
                //
                // effectFocus.renderToScreen = true;
                //
                // composer = new THREE.EffectComposer( renderer );
                //
                // composer.addPass( renderModel );
                // composer.addPass( effectHBlur );
                // composer.addPass( effectBloom );
                // composer.addPass( effectFocus );

                //container.appendChild( renderer.domElement );
            }
            catch (e) {
                console.error( e );
                return;
            }

            gsap.to( '#about-us-canvas', {
                scrollTrigger : {
                    trigger : "#about-us-canvas",
                    markers: false,

                    onUpdate: ( self ) => {
                        //cameraDestPosititionZ = 6 - ( 6 * self.progress );
                        //console.log( self.progress );
                        /*
                        const val = Math.abs( self.progress - 0.5)  * 400;
                        destinationCameraZ = Math.min( -250, -250 - ( val ) );
                        console.log( destinationCameraZ );
*/
                    },

                    onEnter : () => {
                        scene.visible = true;
                    },

                    onEnterBack : () => {
                        scene.visible = true;
                    },

                    onLeave: () => {
                        scene.visible = false;
                    },

                    onLeaveBack : () => {
                        scene.visisble = false;
                    }
                }
            });

            window.addEventListener( 'resize', () =>
            {
                camera.aspect = container.offsetWidth / container.offsetHeight;
                camera.updateProjectionMatrix();
                renderer.setSize( container.offsetWidth, container.offsetHeight );
            });

        }

        function getHeight (x,y) {
            if (isNaN(x) || isNaN(y) ) {
                return 0;
            };
            const data = bumpMapCtx.getImageData(x, y, 1, 1).data;
            return data[0];
        }
        function animate() {

            requestAnimationFrame( animate );

            render();

        }

        function lerp( current, target )
        {
            return ( target - current ) * .1;
        }

        function render() {

            time = new Date().getTime();

            world.rotation.x = Math.sin( time/2000 ) * 0.2 - 0.1;
            world.rotation.y += 0.005;

            //camera.position.z = lerp( destinationCameraZ,camera.position.z );

            //camera.position.z = destinationCameraZ;
            //console.log( camera.position.z );

            camera.lookAt(scene.position);

            renderer.clear();
            composer.render();
        }
    }
}
